const DataTableResultsTotal = ({ total }) => {
    return (
        <div>
            <span className="font-SemiBold">{total}</span> Results
        </div>
    );
};

export default DataTableResultsTotal;
